import { theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { spacing } = theme;

export const wrapper = css`
  margin: ${spacing.xxxl}px ${spacing.sm}px;
  text-align: center;
`;

export const subheading = css`
  margin-bottom: 4rem;
`;
